<template>
  <div class="game-list" v-loadMore="getGameList" v-show="visible" @click.stop>
    <div class="main">
      <ul v-if="showGameList && showGameList.length">
        <li
          class="item"
          v-for="item of showGameList"
          :key="item.roomUid"
          @click="toGameRoom(item)"
        >
          <div class="left">
            <img class="cover" :src="item.coverImgUrl" alt="" srcset="" />
            <div class="room-info">
              <span>{{ item.name }}</span>
              <div class="game-type">
                <span>{{ getGameName(item.gameType) }}</span>
              </div>
            </div>
          </div>
          <div class="right">
            <span class="circle"></span>
            <span class="number">{{ item.userNum }}</span>
            /
            <span class="number">{{ item.seats }}</span>
          </div>
        </li>
      </ul>
      <div class="btn-create" @click="createRoom()">
        創建房間
      </div>
      <create-update
        ref="gameCreateForm"
        @update="initList(roomId)"
      ></create-update>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getGameList as getGameListRequest } from './api';
import CreateUpdate from './create-update.vue';
export default {
  name: 'GameList',
  components: {
    CreateUpdate
  },
  props: {},
  data() {
    return {
      visible: false,
      gameList: [],
      gameListParams: {
        gameType: 1,
        pageSize: 20,
        roomUid: '',
        pageIndex: 0
      },
      gameTotal: 0,
      roomId: ''
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['sudConfig']),
    gameTypes() {
      if (this.sudConfig && this.sudConfig.games) {
        return this.sudConfig.games;
      } else {
        return [];
      }
    },
    showGameList() {
      return this.gameList.filter(item => {
        return item.gameType === 3;
      });
    }
  },
  methods: {
    getGameId(gameType) {
      const game = this.gameTypes.find(item => {
        return item.gameType === gameType;
      });
      if (game) {
        return game.gameId;
      } else {
        return '';
      }
    },
    addClickListener() {
      this.$nextTick(() => {
        this.removeClickListener();
        document.body.addEventListener('click', this.hidden);
      });
    },
    removeClickListener() {
      document.body.removeEventListener('click', this.hidden);
    },
    initList(roomId) {
      this.roomId = roomId;
      this.gameListParams = {
        gameType: 1,
        pageSize: 20,
        roomUid: this.roomId,
        pageIndex: null
      };
      this.gameList = [];
      this.addClickListener();
      this.getGameList();
    },
    async show(roomId) {
      this.visible = true;
      if (!this.sudConfig) {
        await this.$store.dispatch('gameRoom/getSunConfig');
      }
      this.initList(roomId);
    },
    hidden() {
      this.visible = false;
    },
    async getGameList() {
      try {
        if (
          this.gameListParams.pageIndex === null ||
          this.gameList.length < this.gameTotal
        ) {
          if (this.gameListParams.pageIndex === null) {
            this.gameListParams.pageIndex = 0;
          } else {
            this.gameListParams.pageIndex += 1;
          }
          const { data } = await getGameListRequest(this.gameListParams);
          if (!data) {
            this.gameList = this.gameList || [];
            return;
          }
          this.gameList = this.gameList.concat(data.content) || [];
          this.gameTotal = data.totalRemain;
        }
      } catch (error) {
        if (this.gameListParams.pageIndex === 0) {
          this.gameListParams.pageIndex = null;
        } else {
          this.gameListParams.pageIndex -= 1;
        }
      }
    },
    openGame() {},
    getGameName(gameType) {
      let gameName = '';
      if (this.sudConfig && this.sudConfig.games) {
        const game = this.sudConfig.games.find(item => {
          return item.gameType === gameType;
        });
        gameName = game ? game.name : '';
      }
      return gameName;
    },
    createRoom() {
      this.$refs.gameCreateForm.show(this.roomId);
    },
    toGameRoom(game) {
      const gameId = this.getGameId(game.gameType);
      this.$router.replace({
        path: `/game-room/${game.roomUid}/${gameId}`
      });
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.game-list {
  .main {
    width: 100%;
    background-color: rgb(0, 0, 0);
    height: 100%;
    overflow: auto;
    padding: 24px 20px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
  }
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 400px;
  color: white;
  z-index: 10;
  border-radius: 8px;

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border: 1px solid #9c7ee2;
    background-color: rgba(156, 126, 226, 0.4);
    border-radius: 8px;
    margin-bottom: 20px;
    cursor: pointer;
    .left {
      display: flex;
      flex: auto;
      .cover {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: white;
        display: inline-block;
        object-fit: cover;
        margin-right: 10px;
      }
      .room-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .circle {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: white;
        display: inline-block;
      }
    }
  }
  .btn-create {
    width: 100%;
    height: 72px;
    padding: 10px;
    border: 1px dashed #9c7ee2;
    background-color: rgba(156, 126, 226, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 8px;
    flex: none;
  }
  .game-type {
    span {
      background-color: #80bc7e;
      font-size: 12px;
      display: inline-block;
      padding: 2px 4px;
      border-radius: 2px;
    }
  }
}
</style>
